<section *ngIf="shouldAskProductTypeQuestion" class="product-type-question">
  <p class="product-type-question__title">
    {{ productTypeQuestionTitle }}
  </p>
  <section class="product-type-options" [class.selection-made]="selectedOption">
    <label
      *ngFor="let option of options; let i = index"
      class="product-type-option"
      [class.selected]="selectedOption === option"
      [attr.data-testid]="'product-type-option-' + i"
    >
      <input
        type="radio"
        [name]="'productType-' + claimType"
        [value]="option"
        [checked]="selectedOption === option"
        (change)="handleSelection(option)"
      />
      <div class="radio"></div>
      <span>{{ formatOption(option) | capitalcase }}</span>
    </label>
  </section>
</section>

<section class="gas-safety-question" *ngIf="shouldShowGasSafetyQuestion">
  <p class="gas-safety-question__title">
    Do you smell gas or think there's a carbon monoxide leak?
  </p>
  <section class="gas-safety-options">
    <label
      *ngFor="let answer of gasSafetyAnswers"
      class="gas-safety-option"
      [class.selected]="gasSafetyAnswer === answer"
      [attr.data-testid]="answer === 'YES' ? 'gas-option-yes' : 'gas-option-no'"
    >
      <input
        type="radio"
        [name]="'gasSafety-' + claimType"
        [value]="answer"
        [checked]="gasSafetyAnswer === answer"
        (change)="handleGasSafetySelection(answer)"
      />
      <div class="radio"></div>
      <span>{{ answer === 'YES' ? 'Yes' : 'No' }}</span>
    </label>
  </section>
</section>

<section
  class="gas-emergency-followup"
  *ngIf="shouldShowGasSafetyQuestion && gasSafetyAnswer === 'YES'"
>
  <p class="gas-emergency-followup__title">
    <i class="fa-light fa-circle-exclamation fa-lg error-icon"></i>
    What are you reporting?
  </p>
  <section class="gas-emergency-reasons">
    <label
      *ngFor="let reason of gasEmergencyReasons; let i = index"
      class="gas-emergency-option"
      [class.selected]="gasEmergencyReason === reason.value"
      [attr.data-testid]="'gas-emergency-option-' + i"
    >
      <input
        type="radio"
        [name]="'gasEmergencyReason-' + claimType"
        [value]="reason.value"
        [checked]="gasEmergencyReason === reason.value"
        (change)="handleGasEmergencyReasonSelection(reason.value)"
      />
      <div class="radio"></div>
      <span>{{ reason.label }}</span>
    </label>
  </section>
</section>

<section
  *ngIf="gasSafetyAnswer === 'YES' && gasEmergencyReason"
  class="gas-guidance-section-divider"
>
  <h2 class="heading-4" data-testid="gas-guidance-heading">
    Here’s what to do
  </h2>

  <section *ngIf="showGasEmergencyContent" class="gas-safety-help">
    <section class="gas-guidance">
      <p class="body bold">1. Call the National Gas Emergency Service</p>

      <p class="body blocked">
        If you smell gas or have any concerns, call the National Gas Emergency
        Service.
      </p>

      <p class="body blocked">
        It’s free and open at any time. They’ll send an emergency engineer to
        check the leak and advise on the next steps. If there’s a leak, they’ll
        make the gas supply safe.
      </p>
    </section>

    <section class="contact-numbers">
      <section class="number" *ngFor="let contact of gasEmergencyContacts">
        <p class="area-label">{{ contact.area }}</p>
        <a
          class="call-link"
          [class.call-link--disabled]="!isCallLinkInteractive"
          [attr.href]="isCallLinkInteractive ? contact.href : null"
          [attr.tabindex]="isCallLinkInteractive ? null : '-1'"
          [attr.aria-disabled]="!isCallLinkInteractive ? 'true' : null"
          (click)="handleCallLinkClick($event)"
        >
          <i class="fa-light fa-phone call-link-icon" aria-hidden="true"></i>
          <span class="call-link-text">{{ contact.displayNumber }}</span>
        </a>
      </section>
    </section>

    <p class="website-link body">
      Or visit
      <a
        class="link-text"
        href="https://www.nationalgas.com/emergency-contacts"
        target="_blank"
        >www.nationalgas.com</a
      >
    </p>

    <section class="gas-guidance">
      <p class="body bold">
        2. Book a {{ claimType === 'REPAIR' ? 'repair' : 'service' }}
      </p>
      <p class="body blocked">
        You can book a {{ claimType === 'REPAIR' ? 'repair' : 'service' }}, but
        you must contact the National Gas Emergency Service before our engineer
        attends. This is to make sure the appliance is safe for you and the
        engineer.
      </p>

      <div class="national-gas-checkbox-wrapper">
        <label class="custom-checkbox">
          <input
            type="checkbox"
            [checked]="confirmNationalGasContact"
            (change)="handleConfirmationOfContactToNationalGas()"
          />
          <span class="checkmark"> </span>
          <p class="body">
            I confirm that I'll contact the National Gas Emergency Service
            before an engineer attends
          </p>
        </label>
      </div>
    </section>
  </section>
</section>
